module.exports = __webpack_public_path__ + "img/label-4DUPLO.3516ec7e.jpeg";